<ng-container [formGroup]="model">
  <div>Przezroczystość</div>
  <input type="range" min="0" max="1" step="0.001" formControlName="opacity" />

  <div class="mt-3">
    <lib-checkbox formControlName="hasColorOverlay"> Zmień kolor </lib-checkbox>
  </div>
  @if (model.get('hasColorOverlay')?.value) {
    <div class="colorPicker">
      Kolor nakładki:
      <input
        #colorInput
        (colorPickerChange)="model.controls.colorOverlay.patchValue($event)"
        [(colorPicker)]="model.value.colorOverlay"
      [style.background]="
        colorInput.value ? colorInput.value : model.value.colorOverlay
      "
        cpPosition="auto"
        [cpUseRootViewContainer]="true"
        />
      </div>
    }

    <div class="mt-3">
      <lib-checkbox formControlName="hasShadow"> Cień </lib-checkbox>
    </div>
    @if (model.get('hasShadow')?.value) {
      <div>
        <lib-box-shadow-editor formControlName="cssShadowFilter">
        </lib-box-shadow-editor>
      </div>
    }
  </ng-container>
